module.exports = __webpack_public_path__ + "img/avatar.59a9325e.gif";